import React from 'react';
import s from './index.module.css';

const ExpertDialogLeft = () => {
  return (
    <div className={s.content}>
      <div className={s.line}></div>
      <div className={s.title}>Эксперт завершил консультацию</div>
      <div className={s.line}></div>
    </div>
  );
};

export default ExpertDialogLeft;
